import { FieldType } from "../api.js";
import { WalletModelConvertSpec } from "./wallet.specs.js";
import { BaseModelConvertSpec } from "./base.specs.js";
const MemberModelConvertSpec = {
  ...BaseModelConvertSpec,
  primaryWallet: WalletModelConvertSpec,
  referredAt: FieldType.DateTime,
  referralQualifiedAt: FieldType.DateTime
};
const SelfEntityModelConvertSpec = {
  ...BaseModelConvertSpec,
  member: MemberModelConvertSpec
};
const BankListModelConvertSpec = {
  content: {}
};
const WalletTxModelConvertSpec = {
  balance: FieldType.BigNumber,
  amount: FieldType.BigNumber
};
export {
  BankListModelConvertSpec,
  MemberModelConvertSpec,
  SelfEntityModelConvertSpec,
  WalletTxModelConvertSpec
};
